import axios from 'axios';
import { API_BASE } from '../../../scripts/utils/api';

export function toggleOverlay(status) {
  const overlay = document.querySelector('#ProductGridContainer [data-loading]');
  overlay?.classList.toggle('hidden', !status);
}

export async function getLocationData() {
  const storesResp = await fetch(`${API_BASE}/getStores`);
  const apiLocations = await storesResp.json();
  const locations = apiLocations.filter((location) => location.warehouse !== 'true');
  return locations;
}

export async function sendAPIRequest(endpoint, body, RELEWISE_API_KEY, signal) {
  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: RELEWISE_API_KEY,
      },
      body: JSON.stringify(body),
      signal,
    });
    const data = await res.json();
    return data;
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    console.error('[SEARCH] Failed to fetch results', error);
    return [];
  }
}

export function getFacet(name, searchResultData) {
  name = name.replace('filter-', '');
  let resultFacet;
  searchResultData?.facets?.items.forEach((facet) => {
    if (facet.$type === 'Relewise.Client.DataTypes.Search.Facets.Result.ProductDataStringValueFacetResult, Relewise.Client' || facet.$type === 'Relewise.Client.DataTypes.Search.Facets.Result.VariantSpecificationFacetResult, Relewise.Client') {
      if (name.toLowerCase() === facet.key.toLowerCase()) {
        resultFacet = facet;
      } else if ('intersport-dk.myshopify.com_custom.' + name.toLowerCase() === facet.key.toLowerCase()) {
        resultFacet = facet;
      }
    } else if (facet.$type === 'Relewise.Client.DataTypes.Search.Facets.Result.PriceRangeFacetResult, Relewise.Client') {
      if (name.toLowerCase() === 'salesprice') {
        resultFacet = facet;
      }
    }
  });
  return resultFacet;
}

export function getQuery(value) {
  return value.trim();
}

function parseNumericSize(displayName) {
  if (typeof displayName !== 'string') return null;
  const match = displayName.trim().match(/^(\d+)(?:[\s ]+(\d+)\s*\/\s*(\d+))?$/);
  if (!match) return null;
  const whole = parseInt(match[1], 10);
  if (!match[2]) return whole;
  const numerator = parseInt(match[2], 10);
  const denominator = parseInt(match[3], 10);
  if (!denominator) return whole;
  return whole + numerator / denominator;
}

export function sortVariants(allVariants) {
  if (!allVariants) return [];
  return allVariants.sort((a, b) => {
    // Handle numeric shoe sizes, including fractional sizes like "41 1/3" or "42 2/3",
    // which may not appear in size_filter_groups and would otherwise fall through to
    // localeCompare and end up out of order.
    const aNumeric = parseNumericSize(a.displayName);
    const bNumeric = parseNumericSize(b.displayName);
    if (aNumeric !== null && bNumeric !== null) {
      return aNumeric - bNumeric;
    }

    const sizeFilterGroupsValues = relewiseData?.size_filter_groups?.flatMap((group) => group.values) || []; // Make one large array of all the sizes in the filter groups
    const sizeOrder = sizeFilterGroupsValues.length ? sizeFilterGroupsValues : ['XXXS', '3XS', 'XXS', '2XS', 'XS', '1XS', 'S', 'M', 'L', 'XL', '1XL', 'XXL', '2XL', 'XXXL', '3XL', 'XXXXL', '4XL', 'XXXXXL', '5XL', 'XXXXXXL', '6XL'];
    const aIndex = sizeOrder.indexOf(a.displayName);
    const bIndex = sizeOrder.indexOf(b.displayName);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    } else if (aIndex !== -1) {
      return -1;
    } else if (bIndex !== -1) {
      return 1;
    } else {
      return a.displayName.localeCompare(b.displayName, undefined, { numeric: true });
    }
  });
}

let userPromise = null;
export function getUser() {
  if (userPromise) return userPromise;
  userPromise = new Promise((resolve) => {
    const checkInterval = 50;
    const maxAttempts = 40; // 2 seconds max
    let attempts = 0;

    const check = async () => {
      try {
        if (RelewiseWebComponents && typeof RelewiseWebComponents.getRelewiseUIOptions === 'function' && RelewiseWebComponents.getRelewiseUIOptions().contextSettings && typeof RelewiseWebComponents.getRelewiseUIOptions().contextSettings.getUser === 'function') {
          const user = await RelewiseWebComponents.getRelewiseUIOptions().contextSettings.getUser();
          if (user && Object.prototype.hasOwnProperty.call(user, 'temporaryId')) {
            resolve(user);
          } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(check, checkInterval);
          } else {
            resolve(null);
          }
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(check, checkInterval);
        } else {
          resolve(null);
        }
      } catch (error) {
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(check, checkInterval);
        } else {
          resolve(null);
        }
      }
    };

    check();
  });
  // Allow one retry on a failed lookup (app embed not yet loaded)
  userPromise.then((u) => { if (u === null) userPromise = null; });
  return userPromise;
}
